/*
 * Frete grátis por região (CEP) — Plenitude
 * Finaliza o esqueleto deixado no tema: lê #plenitude-cep-region-config,
 * engancha no CEP existente ([data-shipping-cep]), deriva a região via ViaCEP
 * e ajusta o threshold da barra de progresso (<progress-bar>).
 *
 * - Tudo atrás do toggle enable_cep_region (data-enabled). OFF => não faz nada.
 * - ANTES do CEP: barra escondida + linha-convite (não usa o fallback).
 * - DEPOIS do CEP: valor da região; se a UF não resolver, cai no default (fallback).
 * - Persiste CEP/UF em cookie (dias vindos do config). Sem valor hardcoded aqui.
 */
(function () {
  'use strict';

  var CFG = document.getElementById('plenitude-cep-region-config');
  if (!CFG || CFG.dataset.enabled !== 'true') return; // toggle OFF => comportamento nativo do tema

  // ---------- helpers ----------
  function num(x) { var v = parseFloat(String(x == null ? '' : x).replace(',', '.')); return isFinite(v) ? v : 0; }
  function money(v) { return 'R$ ' + v.toFixed(2).replace('.', ','); }

  var COOKIE = 'pl_cep_region';
  var COOKIE_DAYS = parseInt(CFG.dataset.cepCookieDays || '30', 10) || 30;
  var DEFAULT = num(CFG.dataset.defaultThreshold); // reais (fallback, pós-CEP)
  var MSG_PROGRESS = CFG.dataset.msgFreeShippingProgress || 'Faltam {{ amount }} para o FRETE GRÁTIS';
  var MSG_DONE = CFG.dataset.msgFreeShippingDone || 'Você tem FRETE GRÁTIS!';
  var MSG_PROMPT = CFG.dataset.msgCepPrompt || 'Informe seu CEP em "Calcular Frete" e veja o frete grátis da sua região';

  var THRESHOLDS = {
    sp: num(CFG.dataset.thresholdSp),
    sul_sudeste: num(CFG.dataset.thresholdSulSudeste),
    centro_oeste: num(CFG.dataset.thresholdCentroOeste),
    nordeste: num(CFG.dataset.thresholdNordeste),
    norte: num(CFG.dataset.thresholdNorte)
  };

  // Lista fechada UF -> região (valida a UF vinda do ViaCEP; nada de input cru).
  var UF_REGION = {
    SP: 'sp',
    RJ: 'sul_sudeste', MG: 'sul_sudeste', ES: 'sul_sudeste', PR: 'sul_sudeste', SC: 'sul_sudeste', RS: 'sul_sudeste',
    GO: 'centro_oeste', MT: 'centro_oeste', MS: 'centro_oeste', DF: 'centro_oeste',
    MA: 'nordeste', PI: 'nordeste', CE: 'nordeste', RN: 'nordeste', PB: 'nordeste', PE: 'nordeste', AL: 'nordeste', SE: 'nordeste', BA: 'nordeste',
    AC: 'norte', AM: 'norte', RR: 'norte', RO: 'norte', PA: 'norte', AP: 'norte', TO: 'norte'
  };

  var state = load(); // {cep, uf} | null
  var obs = null;
  var scheduled = false;

  // ---------- cookie ----------
  function setCookie(v) {
    var d = new Date(); d.setTime(d.getTime() + COOKIE_DAYS * 864e5);
    document.cookie = COOKIE + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function getCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function load() { try { return JSON.parse(getCookie() || 'null'); } catch (e) { return null; } }
  function save(cep, uf, persist) {
    state = { cep: cep, uf: uf };
    if (persist) { try { setCookie(JSON.stringify(state)); } catch (e) {} }
  }

  // ---------- regra de valor ----------
  function thresholdForUF(uf) {
    var region = UF_REGION[uf];
    var t = region ? THRESHOLDS[region] : 0;
    return (t && t > 0) ? t : DEFAULT; // UF fora do mapa -> default
  }
  // null => antes do CEP (mostra convite). número => aplica na barra.
  function currentThreshold() {
    if (!state) return null;                 // nunca digitou CEP
    if (state.uf) { var t = thresholdForUF(state.uf); return t > 0 ? t : null; }
    return DEFAULT > 0 ? DEFAULT : null;     // CEP digitado, sem região -> fallback
  }

  // ---------- render ----------
  function setText(el, msg, amountStr) {
    var parts = String(msg).split('{{ amount }}');
    el.textContent = '';
    el.appendChild(document.createTextNode(parts[0] || ''));
    if (parts.length > 1) {
      var strong = document.createElement('strong');
      strong.textContent = amountStr;
      el.appendChild(strong);
      el.appendChild(document.createTextNode(parts.slice(1).join('{{ amount }}')));
    }
  }
  function renderBar(bar, threshold) {
    var value = num(bar.getAttribute('value')) / 100; // cart.total_price (centavos) mantido pelo tema
    var done = value >= threshold;
    bar.setAttribute('max', Math.round(threshold * 100));
    bar.setAttribute('data-complete', done ? 'true' : 'false');
    bar.removeAttribute('hidden');
    var fill = bar.querySelector('.progress-bar__bar-fill');
    if (fill) fill.style.width = (done ? 100 : Math.min(100, value / threshold * 100)) + '%';
    var text = bar.querySelector('.progress-bar__text');
    if (text) {
      if (done) text.textContent = MSG_DONE;
      else setText(text, MSG_PROGRESS, money(Math.max(0, threshold - value)));
    }
  }
  function wrapOf(bar) { return bar.closest('.cart-heading__progress') || bar.parentElement; }
  function showCue(bar) {
    var wrap = wrapOf(bar); if (!wrap) return;
    var cue = wrap.querySelector('.pl-cep-cue');
    if (!cue) {
      cue = document.createElement('div');
      cue.className = 'pl-cep-cue';
      cue.setAttribute('role', 'status');
      wrap.appendChild(cue);
    }
    cue.textContent = '📍 ' + MSG_PROMPT;
    cue.hidden = false;
  }
  function hideCue(bar) {
    var wrap = wrapOf(bar);
    var cue = wrap && wrap.querySelector('.pl-cep-cue');
    if (cue) cue.hidden = true;
  }

  function applyAll() {
    if (obs) obs.disconnect(); // evita auto-disparo pelas nossas próprias mutações
    try {
      var threshold = currentThreshold();
      var bars = document.querySelectorAll('progress-bar.progress-bar');
      for (var i = 0; i < bars.length; i++) {
        var bar = bars[i];
        if (threshold) { hideCue(bar); renderBar(bar, threshold); }
        else { bar.setAttribute('hidden', ''); showCue(bar); }
      }
    } finally {
      if (obs) obs.observe(document.body, { childList: true, subtree: true });
    }
  }
  function scheduleApply() {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applyAll(); });
  }

  // ---------- CEP ----------
  function lookup(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && !d.erro && d.uf) ? String(d.uf).toUpperCase() : null; })
      .catch(function () { return null; });
  }
  function onCep(raw) {
    var cep = String(raw || '').replace(/\D/g, '');
    if (cep.length !== 8) return;
    if (state && state.cep === cep) { scheduleApply(); return; } // já resolvido
    lookup(cep).then(function (uf) {
      if (uf && UF_REGION[uf]) save(cep, uf, true);   // resolvido -> persiste
      else save(cep, null, false);                    // falhou/UF fora -> só sessão (default)
      scheduleApply();
    });
  }
  function hookInputs() {
    var inputs = document.querySelectorAll('[data-shipping-cep], [data-plenitude-mini-cart-cep], input[name="cep"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.__plHooked) continue; inp.__plHooked = true;
      var fire = (function (el) { return function () { onCep(el.value); }; })(inp);
      inp.addEventListener('change', fire);
      inp.addEventListener('blur', fire);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') setTimeout(fire, 0); });
    }
  }

  // ---------- css do convite ----------
  function injectStyle() {
    if (document.getElementById('pl-cep-cue-style')) return;
    var s = document.createElement('style');
    s.id = 'pl-cep-cue-style';
    s.textContent =
      '.pl-cep-cue{font-size:13px;line-height:1.45;color:#5b4a55;text-align:center;padding:10px 14px;font-family:var(--montserrat,inherit)}' +
      // o tema tem display próprio na barra que ignora o atributo [hidden] — força o esconder
      'progress-bar.progress-bar[hidden]{display:none!important}' +
      // esconde a régua duplicada do bundle (lógica antiga da agência) — fica só a barra bonita
      '.plenitude-free-shipping-ruler{display:none!important}';
    document.head.appendChild(s);
  }

  // ---------- init ----------
  function init() {
    injectStyle();
    hookInputs();
    applyAll();
    obs = new MutationObserver(function () { hookInputs(); scheduleApply(); });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* pl-pix-fix: o bundle da agencia calcula o TOTAL pix do carrinho com 5% cravado
   (updatePixDiscount -> Math.round(s*.05)). Este override le settings.pix_discount
   (injetado em window.Shopify.theme.settings pelo theme.liquid) e sobrevive a
   rebuilds do bundle (main-*.js). Se o metodo sumir num rebuild, vira no-op. */
(function () {
  if (!window.customElements || !customElements.whenDefined) return;
  function money(cents) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  }
  customElements.whenDefined('cart-checkout').then(function () {
    var C = customElements.get('cart-checkout');
    if (!C || !C.prototype || typeof C.prototype.updatePixDiscount !== 'function') return;
    C.prototype.updatePixDiscount = function (t) {
      var e = this.querySelector('.cart-checkout__pix-text');
      var i = this.querySelector('.cart-checkout__pix-value');
      if (!e || !i) return;
      var s;
      if (t !== undefined) {
        s = t;
        e.setAttribute('data-total-price', money(t));
      } else {
        s = Number(String(e.dataset.totalPrice || '').replace(/\D/g, '')) || 0;
      }
      i.textContent = money(s);
    };
    document.querySelectorAll('cart-checkout').forEach(function (el) {
      try { el.updatePixDiscount(); } catch (err) {}
    });
  }).catch(function () {});
})();

/* pl-pix-cards: cards de beneficio (metaobject) com "N% OFF ... Pix" seguem a config
   settings.pix_discount — se o time mudar o % e esquecer o card, o front corrige. */
(function () {
  function sync() {
    var v = Number(window.Shopify && Shopify.theme && Shopify.theme.settings && Shopify.theme.settings.pix_discount);
    if (!isFinite(v) || v <= 0 || v >= 100) return;
    var label = String(v).replace('.', ',') + '% OFF';
    document.querySelectorAll('p.text-block').forEach(function (p) {
      if (!/pix/i.test(p.textContent || '')) return;
      p.querySelectorAll('strong, b').forEach(function (s) {
        var t = (s.textContent || '').trim();
        if (/^\d+(?:[.,]\d+)?%\s*OFF$/.test(t) && t !== label) s.textContent = label;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
